import { RECORDS_PER_PAGE } from '@/constants/data';
import BaseService from './base.service';

const baseService = new BaseService('schoolgroup-admin');

export default {
  getDistrictAdmins: (params: any = {}) => {
    const queryParams = new URLSearchParams({
      page: (params.page || 1).toString(),
      perPage: RECORDS_PER_PAGE.toString(),
    });

    if (params.search && params.search.trim() !== '') {
      queryParams.append('search', params.search);
    }

    if (params.country) {
      queryParams.append('country_id', params.country);
    }

    if (params.active !== null && params.active !== undefined) {
      queryParams.append('active', params.active.toString());
    }

    return baseService.get(`findAll?${queryParams}`);
  },

  createDistrictAdmin: (districtAdmin: any) => baseService.post('create', districtAdmin),

  updateDistrictAdmin: (id: number, districtAdmin: any) => baseService.put(`update/${id}`, districtAdmin),

  getDistrictAdmin: (id: number) => baseService.get(`findOne/${id}`),

  deleteMultipleDistrictAdmins: (ids: number[]) => baseService.del('delete-multiple', { ids }),
};
